import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterModule } from '@angular/router';
import { PermissionForStudents } from '@edtech-ui/access-role-permissions/users-permissions-constants/student-roles-permissions.enum';
import { HasPermissionDirective } from '@edtech-ui/access-role-permissions/users-permissions-directives/has-permissions.directives';
import { ProCoursesStatusEnum } from '@edtech-ui/constants/pro-courses-status.enum';
import { StudentPublishedCourse, StudentPublishedCoursesResponse } from '@edtech-ui/core/models/student-courses-v2/student-get-all-published-courses';
import { StudentCoursesService } from '@edtech-ui/core/services/student-courses/student-courses.service';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import { catchError, finalize, of, Subscription, tap } from 'rxjs';

@Component({
	selector: 'app-professional-courses',
	standalone: true,
	imports: [MatIconModule, CommonModule, MatProgressSpinnerModule, RouterModule,MatTooltipModule,
		HasPermissionDirective
	],
	templateUrl: './professional-courses.component.html',
	styleUrl: './professional-courses.component.scss'
})
export class ProfessionalCoursesComponent implements OnInit, OnDestroy {

	isCourseInProgressLoading = false;
	isCourseCompletedLoading = false;
	totalCourseCount: number = 0
	studentCourse: StudentPublishedCourse[] = [];
	subscription = new Subscription();
	isLoading = false;
	classId = environment.classroomId;
	page = 1;
	pageSize = 10;
	limit = 10;
	totalCoursePages = 0;
	proCoursesStatusEnum = ProCoursesStatusEnum
	selectedTab: ProCoursesStatusEnum = ProCoursesStatusEnum.ALL_PROGRAM;
	selectTab(tab: ProCoursesStatusEnum) {
		this.selectedTab = tab
	}

	PermissionForStudents = PermissionForStudents;

	constructor(
		private router: Router,
		private _studentCourseService: StudentCoursesService,
		private _toastr: ToastrService,
	) { }

	ngOnInit(): void {
		this.getAllStudentCourses();
	}

	goToCourseDescriptionPage(courseId: string) {
		this.router.navigate(['/student-dashboard/course-detail-page', this.classId, courseId])
	}

	getAllStudentCourses(loadMore = false) {
		this.isLoading = true;
		this.subscription.add(
			this._studentCourseService.getAllStudentPublishedCourses(this.classId, this.page, this.pageSize).pipe(
				tap((response: StudentPublishedCoursesResponse) => {
					if (response.Success) {
						this.totalCoursePages = response.Data.total_pages;
						this.totalCourseCount = response.Data.total;
						if (loadMore) {
							this.studentCourse = [...this.studentCourse, ...response.Data.courses];
						} else {
							this.studentCourse = response.Data.courses;
						}
					} else {
						this._toastr.error(response.Message);
					}
				}),
				finalize(() => {
					this.isLoading = false;
				}),
				catchError(() => {
					this._toastr.error('Something went wrong.Please try again');
					return of(null);
				})
			).subscribe()
		);
	}

	truncate(text: string, words = 100): string {
		if (!text) return '';
		const arr = text.split(' ');
		return arr.length > words ? arr.slice(0, words).join(' ') + '...' : text;
	}

	goToDetailPage(courseId: string) {
		this.router.navigate(['/student-dashboard/course-details', courseId])
	}

	loadMore() {
		if (this.page < this.totalCoursePages) {
			this.page++;
			this.getAllStudentCourses(true);
		}
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

}